import { render, staticRenderFns } from "./lecture.vue?vue&type=template&id=ba240038&scoped=true&"
import script from "./lecture.vue?vue&type=script&lang=js&"
export * from "./lecture.vue?vue&type=script&lang=js&"
import style0 from "./lecture.vue?vue&type=style&index=0&id=ba240038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba240038",
  null
  
)

export default component.exports